import { Link } from "react-router-dom";
import "./Signup.css";

function Signup() {
  return (
    <div className="d-none d-md-flex column-gap-1">
      <Link to="/login" className="text-decoration-none">
        <div className="header-button ms-1 blueShadow blueBackground">
          <img src="/postupPics/menu/login.png" />
          <strong> ورود </strong>
        </div>
      </Link>
      <Link to="/register" className="text-decoration-none">
        <div className="header-button blueShadow blueBackground">
          <img src="/postupPics/menu/register.png" />
          <strong> ثبت نام </strong>
        </div>
      </Link>
    </div>
  );
}

export default Signup;
